import {
  ButtonERP,
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
  TagERP,
} from "@finanedi.es/storybook"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TokenSender from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenSender"
import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { GetFacturasFinanciablesDtoProps } from "api/DTOs/GetFacturasFinanciablesDto"
import {
  FinanciablesQueryParamsProps,
  getFacturasByIdSimple,
  getFacturasFinanciables,
  postFacturaFinanciar,
} from "api/Factura.service"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import ActionToast from "common/components/ActionToast"
import { getOptionFacturasModal } from "common/components/DirectAccess/constant"
import { KEYS, getValidUrl } from "common/components/MdfDialog/constants"
import Modal from "common/components/Modal/Modal"
import ModalVerDocumento from "common/components/ModalVerDocumento/ModalVerDocumento"
import NoDataTemplate from "common/components/NoDataTemplate"
import { AppContext } from "common/context/WithAppWrapper"
import { STATIC_ASSETS_URL } from "common/context/constants"
import useRedirectToExternalApp from "common/hooks/useRedirectToExternalApp"
import useToggle from "common/hooks/useToggle"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import ImportDownloadModal from "features/Documentos/components/DocumentosActions/modals/ImportDownloadModal"
import { handleTableSelection } from "handlers/handleTableSelection"
import { useFilterMenu } from "hooks/useFilterMenu"
import { ProgressBar } from "primereact/progressbar"
import { Skeleton } from "primereact/skeleton"
import { useCallback, useContext, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { frontendCurrency } from "utils/formatCurrency"
import FilterMenu from "./FilterMenu"
import { COLUMNAS_FACTURAS_FINANCIABLES } from "./constants/FacturasFinanciablesColumns"

const FacturasFinanciables = () => {
  const { t } = useTranslation()
  const [sortingCriteria, setSortingCriteria] = useState<
    FinanciablesQueryParamsProps["SortingCriteria"]
  >({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [modalDocumentoDetail, setModalDocumentoDetail] = useState<{
    show: boolean
    document: FacturaReadingSimpleDtoProps | null
  }>({
    show: false,
    document: null,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const [selection, setSelection] = useState<{
    items: GetFacturasFinanciablesDtoProps[]
    saldoTotal: number
  }>({ items: [], saldoTotal: 0 })
  const dtRef =
    useRef<DataTablePrimeReact<GetFacturasFinanciablesDtoProps[]>>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const [show, toggle] = useToggle()

  const {
    showModal,
    handleAplications,
    progressValue,
    toggleShowModal,
    message,
    aplicationKey,
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  } = useRedirectToExternalApp()

  const handleRedirect = (appKey: $TSMigrationFixMe) => {
    handleAplications(appKey)
    toggleShowModal(!showModal)
  }
  const history = useHistory()
  // @ts-expect-error TS(2339): Property 'settings' does not exist on type 'unknow...
  const { settings } = useContext(AppContext)

  const fetchItems = useCallback(() => {
    return (queryState: FinanciablesQueryParamsProps) =>
      getFacturasFinanciables({
        ...queryState,
        SortingCriteria:
          queryState.SortingCriteria ?? "FechaEmision DESC, CreationTime DESC",
      })
  }, [])

  const { items, isLoading, totalCount, setServiceQuery } = useFilterMenu({
    serviceCall: fetchItems,
  })

  const onRenderContent = useMemo(() => {
    return (
      <div className='tw-flex tw-justify-between md:tw-justify-start tw-items-center md:whitespace-nowrap md:ml-8'>
        <span className='tw-font-medium'>
          {t("crear.factura.finance.selectedLabel")} {selection.items.length}
        </span>
        <span className='ml-4 tw-font-medium tw-text-lg'>
          {t("crear.factura.finance.importTotalLabel")}
          {frontendCurrency(selection.saldoTotal)}
        </span>
      </div>
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selection.items])

  const handleHideToast = () => {
    setSelection({ items: [], saldoTotal: 0 })
  }

  const handleSendFacturasAFinanciar = async () => {
    try {
      await postFacturaFinanciar({
        excluidoIds: [],
        ids: selection.items
          .map((item) => item.id)
          .filter((id): id is string => id !== undefined),
      })
      handleRedirect(KEYS.GEFINTECH_INVOICES) // TODO DO NOT REMOVED THIS YET, UNTIL GEFINTECH IS READY
      // handleRedirect(KEYS.GEFINTECH);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
    }
  }
  const handleOpenModalDocumento = async (id: string) => {
    const facturaById = await getFacturasByIdSimple(id)
    setModalDocumentoDetail({
      show: true,
      document: facturaById,
    })
  }

  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
  }

  return (
    <div className='tw-overflow-hidden tw-h-full tw-flex tw-flex-col'>
      <TokenSender
        message={message}
        targetUrl={import.meta.env.REACT_APP_ACCOUNTS}
      />
      <TagERP
        color='info'
        icon={<FontAwesomeIcon icon={faInfoCircle} />}
        value={t("crear.factura.finance.warningMsg")}
        className='tw-w-full !tw-rounded-none !tw-justify-start'
      />
      <div className='tw-flex tw-w-full tw-shadow-3x2 tw-bg-simple-10 tw-py-3.5 tw-px-8 tw-m-px tw-flex-row tw-justify-between tw-flex-wrap'>
        <div className='tw-text-xl tw-font-normal tw-flex tw-items-center tw-text-nowrap'>
          {t("crear.factura.finance.title")} (
          {isLoading ? (
            <Skeleton className='!tw-h-5 !tw-w-8 !tw-mx-1' />
          ) : (
            <span>{totalCount}</span>
          )}
          )
        </div>

        <div className='tw-flex tw-flex-row tw-gap-3'>
          <FilterMenu
            serviceQuery={setServiceQuery}
            sortingCriteria={sortingCriteria}
            maxResultCount={pagination.itemsPerPage}
            skipCount={pagination.skipCount}
            resetPagination={handleResetPagination}
          />
          <ButtonERP
            customize={{
              size: "md",
              type: "transparent",
            }}
            onClick={() => history.goBack()}
            label={`${t("crear.factura.financeExitLabel")}`}
          />
        </div>
      </div>
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-94px)] tw-relative '>
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            refTable={dtRef}
            columns={COLUMNAS_FACTURAS_FINANCIABLES(t)}
            className='tw-h-full !tw-z-0'
            columnResizeMode='expand'
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            removableSort
            value={items}
            showGridlines
            lazy
            dataKey='id'
            scrollable
            size='small'
            onRowClick={async ({
              data,
            }: {
              data: GetFacturasFinanciablesDtoProps
            }) => {
              if (!data?.id) return
              handleOpenModalDocumento(data.id)
            }}
            selection={selection.items}
            selectionMode='checkbox'
            selectionColumnMode='multiple'
            onSelectionChange={async ({
              value,
              type,
            }: {
              originalEvent: React.SyntheticEvent
              value: GetFacturasFinanciablesDtoProps[]
              type?: "multiple" | "all" | "checkbox" | "row" | undefined
            }) => {
              const result = handleTableSelection({
                currentSelection: selection.items,
                value,
                type,
                currentPageItems: items,
                calculateTotal: (items: GetFacturasFinanciablesDtoProps[]) =>
                  items.reduce((acc, item) => acc + (item.importe ?? 0), 0),
              })

              setSelection({
                items: result.items,
                saldoTotal: result.total,
              })
            }}
            loading={isLoading}
            emptyMessage={
              <NoDataTemplate
                icon={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/tablas/facturas-de-venta.svg`}
                title='crear.factura.saleLabel'
                description='shared.noDataDescription'
                actionLabel='crear.factura.addOrder'
                actionCommand={() => history.push(ROUTES.CREAR_FACTURA)}
              />
            }
          />
        </div>
        <PaginationERP
          className={PAGINATION_STYLES}
          totalRecords={totalCount}
          first={pagination.skipCount}
          rows={pagination.itemsPerPage}
          resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
          setPagination={setPagination}
          optionDropdown={[10, 20, 50, 100]}
          texts={{
            textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
            textCurrentPageReport: `${t("pagination.from")}`,
          }}
        />
      </div>

      <ImportDownloadModal
        onHide={toggle}
        visible={show}
        title={t("crear.factura.finance.importLabel")}
        subtitle={t("crear.factura.finance.importMsgLabel")}
        options={getOptionFacturasModal(history.push, settings)}
      />
      <ActionToast
        show={Boolean(selection.items.length)}
        onConfirm={() => handleSendFacturasAFinanciar()}
        onHide={handleHideToast}
        content={onRenderContent}
        buttonLabel={t("crear.factura.finance.financeLabel")}
      />

      <Modal
        size='small'
        className='mercado-facturas-dialog'
        visible={showModal}
        onHide={toggleShowModal}
        closable={false}
        draggable={false}
        header={
          <div className='mercado-facturas-dialog__content-header'>
            <img
              // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
              alt={t("crear.finance.altLogoLabel")}
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
              src={getValidUrl(settings)[aplicationKey].logo}
            />
          </div>
        }
      >
        <ProgressBar
          value={progressValue}
          showValue={false}
        />
      </Modal>
      <ModalVerDocumento
        showModal={modalDocumentoDetail.show}
        onHide={() =>
          setModalDocumentoDetail({
            show: false,
            document: null,
          })
        }
        docType={TIPO_DOCUMENTO_ENUM.FACTURA}
        documentoID={modalDocumentoDetail.document?.id ?? null}
        typeDocumentTable='facturas'
        showActions={false}
        isVenta
      />
    </div>
  )
}

export default FacturasFinanciables
